import styled from "styled-components";
import { BASE_URL, VERSION_NUMBER } from "../../types/constant";

export const InformationBoard = () => {
  return (
    <InformationBoardContainer>
      <InformationTitle>시스템 정보</InformationTitle>
      <InformationItem>{`관리자 웹 버전 : ${VERSION_NUMBER}`}</InformationItem>
      <InformationItem>{`서버 URL : ${BASE_URL}`}</InformationItem>
    </InformationBoardContainer>
  );
};

const InformationBoardContainer = styled.div``;

const InformationTitle = styled.div`
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.375rem;
  color: rgb(0, 0, 0);
`;

const InformationItem = styled.li`
  font-weight: 500;
  font-size: 0.813rem;
  line-height: 1rem;
  color: rgb(77, 83, 92);
  margin: 20px;
`;
